/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { AutocompleteItemDto, ID, WithVersion } from '@gh/common-shared-data';

import { JobContractDaysPeriodType } from '../../system-vars/system-vars.dto';

export const JOB_NOT_PROCEEDING_REASON_OTHER = '10';

export type JobScheduleTaskDto = AutocompleteItemDto & {
  date: Date;
};

export type JobDatesTabInfoDto = WithVersion<{
  depositDate?: Date;
  specification?: string;
  csDate?: Date;
  csSignedByClientDate?: Date;
  csSignedByOfficeDate?: Date;
  financeApprovedDate?: Date;
  contractDate?: Date;
  saleDate?: Date;
  councilApprovedDate?: Date;
  councilPermitNumber?: number;
  authToCommenceDate?: Date;
  cocIssueDate?: Date;
  contractStartDate?: Date;
  initialClaimDate?: Date;
  constructionDays?: number;
  timeExtensionLetterDays?: number;
  varsDays?: number;
  contracturalCompletionDate?: Date;
  constructionPeriodIncludes?: JobContractDaysPeriodType;
  completedDate?: Date;
  finalClaimDate?: Date;
  notProceedingDate?: Date;
  notProceedingReason?: number | string;
  notProceedingReasonOther?: string;
  handoverDate?: Date;
  finalizedDate?: Date;
  workingDays?: number;
  nonWorkingDays?: number;
  sundaysAndSaturdays?: number;
  isNotProceeding: boolean;
  isFinalized?: boolean;
  isCocClientIssue?: boolean;
  isAuthToCommence?: boolean;
  isCocComplianceIssued: boolean;
  isContract?: boolean;
  isCocGjgIssue?: boolean;
  isContractStartDateOverridden?: boolean;
  isCouncilApproved?: boolean;
  isFinanceApproved?: boolean;
  supervisorId?: ID;
  jobUseCodeOfComplience: boolean;
  scheduleStartDate: Date;
  scheduleCompleteDate: Date;
  scheduleSlabDate: Date;
  scheduleDrawRuleTasks: JobScheduleTaskDto[];
  scheduleRootTasks: JobScheduleTaskDto[];
  isDrawAmountsPaid: boolean;
  isNotFullyPaidContract: boolean;
  isVariationsExists: boolean;
  isSupervisorExist: boolean;
}>;

export type ContracturalCompletionRequestDto = {
  contractStartDate: Date;
  constructionDays: number;
  timeExtensionLetterDays: number;
};

export type ContracturalCompletionResponseDto = {
  workingDays: number;
  variationDays: number;
  nonWorkingDays: number;
  sundaysAndSaturdays: number;
  contracturalCompletionDate: Date;
};
